/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_Task_FallbackInputs */

const cs_page_title_task_fallback = /** @type {(inputs: Page_Title_Task_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úkol`)
};

const en_page_title_task_fallback = /** @type {(inputs: Page_Title_Task_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task`)
};

/**
* | output |
* | --- |
* | "Task" |
*
* @param {Page_Title_Task_FallbackInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const page_title_task_fallback = /** @type {((inputs?: Page_Title_Task_FallbackInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_Task_FallbackInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_page_title_task_fallback(inputs)
	return cs_page_title_task_fallback(inputs)
});